import { Outlet } from 'react-router-dom';

export default function MinimalLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
